import { createSelector } from 'reselect'
import { StateInterface } from '../types/states'

const selectToursDomain = (state: StateInterface) => state.tours

const selectCurrentTour = createSelector(selectToursDomain, domain => domain.currentTour)

export { selectCurrentTour }
